export const latticeBorderFrame = () => ({
  id: 'lattice-border-frame',
  name: 'Lattice Border Frame',
  thumbnail: '/assets/diploma-templates/06_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/06_background.svg',
      key: null
    }
  }
});
